import { useChannelContext } from "client/components/channel"
import dynamic from "next/dynamic"
import { useEffect } from "react"
import {
  desktopSubtitlesFont,
  mobileSubtitlesFont,
} from "shared/styles/mixins"
import styled from "styled-components"

import { useVideoAnalyticsEvents } from "../player/useVideoAnalyticsEvents"
import { useVideoContext } from "../player/VideoContext"
import { PlayerErrorCode } from "../types"

const DynamicHlsPlayer = dynamic(() => import("./VodHLSPlayer"), {
  ssr: false,
})

const VideoWrapper = styled.div<{
  $visible: boolean
  $mobileSubtitles: boolean
  $subtitleBottom: number
}>`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;

  display: ${(props) => (props.$visible ? "flex" : "none")};
  position: relative;
  background-color: ${(props) => props.theme.videoLetterboxBackground};

  justify-content: center;
  align-items: center;

  ${(props) =>
    props.$mobileSubtitles ? mobileSubtitlesFont : desktopSubtitlesFont}

  // Adjusts vertical position in everything except firefox: In firefox, need to edit VTTCue in js
  > ::-webkit-media-text-track-container {
    transform: translateY(-${(props) => props.$subtitleBottom}px);
  }
`

interface Props {
  mobileSubtitles?: boolean
}

const VideoPlayer = ({ mobileSubtitles }: Props) => {
  const {
    playerError,
    setPlayerError,
    subtitleBottom,
    videoElement,
    alreadyPlayed,
  } = useVideoContext()

  const { recording } = useChannelContext()

  useVideoAnalyticsEvents(videoElement)

  const onFatalError = (err) => setPlayerError(err)
  useEffect(() => {
    if (!recording.vodHlsUrl) {
      setPlayerError({ code: PlayerErrorCode.RECORDING_NOT_FOUND })
    }
  }, [recording.vodHlsUrl])

  if (!recording.vodHlsUrl) {
    return null
  }

  return (
    <>
      <VideoWrapper
        className="videoWrapper"
        $visible={alreadyPlayed && !playerError}
        $mobileSubtitles={mobileSubtitles}
        $subtitleBottom={subtitleBottom}
      >
        <DynamicHlsPlayer
          manifestUrl={recording.vodHlsUrl}
          onFatalError={onFatalError}
          mobileSubtitles={mobileSubtitles}
          live
        />
      </VideoWrapper>
    </>
  )
}

export default VideoPlayer
